<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackBar" color="#e7ab5f" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card>
          <v-card-title class="elevation-1">
            Vision-Mission-Values
            <v-spacer></v-spacer>
            <!-- <v-flex cols="12" sm="3">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                solo
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex> -->
          </v-card-title>
          <div>
            <v-tabs v-model="tab" background-color="white" color="red" grow>
              <v-tab> Vision </v-tab>
              <v-tab> Mission </v-tab>
              <v-tab> Values </v-tab>
              <v-tab-item>
                <div v-if="!storage.vision">
                  <v-dialog
                    :retain-focus="false"
                    v-model="dialog"
                    persistent
                    max-width="600px"
                    :key="dialog"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn outlined color="red" v-bind="attrs" v-on="on">
                        Add
                      </v-btn>
                    </template>
                    <v-card>
                      <v-form v-model="addslider">
                        <v-card-title>
                          <span class="headline">Add Vision</span>
                        </v-card-title>
                        <v-card-text>
                          <v-layout>
                            <v-flex xs12 md12 lg12>
                              <v-text-field
                                row="4"
                                outlined
                                v-model="vheading"
                                label="Heading"
                                :rules="[rules.required]"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs12 md12 lg12>
                              <v-textarea
                                outlined
                                row="4"
                                v-model="vtext"
                                label="Text"
                                :rules="[rules.required]"
                                required
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs12 md12 lg12>
                              <v-img
                                v-if="imagePreview"
                                :src="imagePreview"
                                width="400px"
                                height="200px"
                                class="align-center"
                                contain
                              /><br />
                              <v-btn outlined @click="$refs.showImage.click()"
                                >Upload Image
                                <v-item-group>
                                  <input
                                    v-show="false"
                                    label="Upload Image"
                                    ref="showImage"
                                    id="file"
                                    type="file"
                                    style="display: none"
                                    @change="showImage"
                                  />
                                  <!-- </v-file-input> -->
                                </v-item-group>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="dialogclose()"
                          >
                            Close
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            :disabled="!addslider"
                            @click="addVision()"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </div>
                <div v-else>
                  <v-container grid-list-md>
                    <v-layout wrap pt-10 pb-10>
                      <v-flex md3 pa-4>
                        <v-card
                          v-if="storage.vision.image"
                          style="line-height: 16px; cursor: pointer"
                          tile
                          flat
                        >
                          <v-img
                            contain
                            :src="baseURL + storage.vision.image"
                            height="300px"
                            cover
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#FF2323"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <v-layout wrap justify-center px-2>
                            <br />
                            <v-flex
                              px-4
                              xl12
                              xs12
                              sm12
                              lg12
                              md12
                              justify-center
                            >
                              <span
                                style="
                                  font-size: 16px;
                                  color: #000000;
                                  font-weight: bold;
                                "
                              >
                                {{ storage.vision.heading }}
                              </span>
                            </v-flex>
                            <v-flex
                              px-4
                              xl12
                              xs12
                              sm12
                              lg12
                              md12
                              justify-center
                            >
                              <span style="font-size: 16px; color: #000000">
                                {{ storage.vision.text }}
                              </span>
                            </v-flex>
                            <v-flex
                              pt-5
                              px-4
                              xl6
                              sm6
                              lg6
                              xs6
                              md6
                              justify-center
                            >
                              <v-dialog v-model="editdialog1" max-width="600px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    small
                                    class="mr-2"
                                    outlined
                                    v-on="on"
                                    v-bind="attrs"
                                    color="red"
                                  >
                                    Edit
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-form v-model="addslider">
                                    <v-card-title>
                                      <span class="headline">Edit Vision</span>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-layout>
                                        <v-flex xs12 md12 lg12>
                                          <v-text-field
                                            row="4"
                                            outlined
                                            v-model="vheading"
                                            label="Heading"
                                            :rules="[rules.required]"
                                            required
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout>
                                        <v-flex xs12 md12 lg12>
                                          <v-textarea
                                            outlined
                                            row="4"
                                            v-model="vtext"
                                            label="Text"
                                            :rules="[rules.required]"
                                            required
                                          ></v-textarea>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout wrap>
                                        <v-flex xs12 md12 lg12>
                                          <!-- <v-img
                                            v-if="vision.image && !imagePreview"
                                            :src="baseURL + vision.image"
                                            width="400px"
                                            height="200px"
                                            class="align-center"
                                          /><br /> -->
                                          <v-img
                                            v-if="imagePreview"
                                            :src="imagePreview"
                                            width="400px"
                                            height="200px"
                                            class="align-center"
                                            contain
                                          /><br />
                                          <v-btn
                                            outlined
                                            @click="$refs.showImage.click()"
                                            >Upload Image
                                            <v-item-group>
                                              <input
                                                v-show="false"
                                                label="Upload Image"
                                                ref="showImage"
                                                id="file"
                                                type="file"
                                                style="display: none"
                                                @change="showImage"
                                              />
                                              <!-- </v-file-input> -->
                                            </v-item-group>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="editdialog1 = false"
                                      >
                                        Close
                                      </v-btn>
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        :disabled="!addslider"
                                        @click="addVision()"
                                      >
                                        Save
                                      </v-btn>
                                    </v-card-actions>
                                  </v-form>
                                </v-card>
                              </v-dialog>
                            </v-flex>
                            <br />
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-tab-item>
              <v-tab-item>
                <div v-if="!storage.mission">
                  <v-dialog
                    :retain-focus="false"
                    v-model="dialog"
                    persistent
                    max-width="600px"
                    :key="dialog"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn outlined color="red" v-bind="attrs" v-on="on">
                        Add
                      </v-btn>
                    </template>
                    <v-card>
                      <v-form v-model="addslider">
                        <v-card-title>
                          <span class="headline">Add Mission</span>
                        </v-card-title>
                        <v-card-text>
                          <v-layout>
                            <v-flex xs12 md12 lg12>
                              <v-text-field
                                row="4"
                                outlined
                                v-model="mheading"
                                label="Heading"
                                :rules="[rules.required]"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs12 md12 lg12>
                              <v-textarea
                                outlined
                                row="4"
                                v-model="mtext"
                                label="Text"
                                :rules="[rules.required]"
                                required
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs12 md12 lg12>
                              <v-img
                                v-if="imagePreview"
                                :src="imagePreview"
                                width="400px"
                                height="200px"
                                class="align-center"
                                contain
                              /><br />
                              <v-btn outlined @click="$refs.showImage.click()"
                                >Upload Image
                                <v-item-group>
                                  <input
                                    v-show="false"
                                    label="Upload Image"
                                    ref="showImage"
                                    id="file"
                                    type="file"
                                    style="display: none"
                                    @change="showImage"
                                  />
                                  <!-- </v-file-input> -->
                                </v-item-group>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="dialogclose()"
                          >
                            Close
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            :disabled="!addslider"
                            @click="addMission()"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </div>
                <div v-else>
                  <v-container grid-list-md>
                    <v-layout wrap pt-10 pb-10>
                      <v-flex md3 pa-4>
                        <v-card
                          style="line-height: 16px; cursor: pointer"
                          v-if="storage.mission.image"
                          tile
                          flat
                        >
                          <v-img
                            contain
                            :src="baseURL + storage.mission.image"
                            height="300px"
                            cover
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#FF2323"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <v-layout wrap justify-center px-2>
                            <br />
                            <v-flex px-4 xl2 justify-center>
                              <span
                                style="
                                  font-size: 16px;
                                  color: #000000;
                                  font-weight: bold;
                                "
                              >
                                {{ storage.mission.heading }}
                              </span>
                            </v-flex>
                            <v-flex px-4 xl2 justify-center>
                              <span style="font-size: 16px; color: #000000">
                                {{ storage.mission.text }}
                              </span>
                            </v-flex>
                            <v-flex pt-5 px-4 xl2 justify-center>
                              <v-dialog v-model="editdialog2" max-width="600px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    small
                                    class="mr-2"
                                    outlined
                                    v-on="on"
                                    v-bind="attrs"
                                    color="red"
                                  >
                                    Edit
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-form v-model="addslider">
                                    <v-card-title>
                                      <span class="headline">Edit Mission</span>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-layout>
                                        <v-flex xs12 md12 lg12>
                                          <v-text-field
                                            row="4"
                                            outlined
                                            v-model="mheading"
                                            label="Heading"
                                            :rules="[rules.required]"
                                            required
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout>
                                        <v-flex xs12 md12 lg12>
                                          <v-textarea
                                            outlined
                                            row="4"
                                            v-model="mtext"
                                            label="Text"
                                            :rules="[rules.required]"
                                            required
                                          ></v-textarea>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout wrap>
                                        <v-flex xs12 md12 lg12>
                                          <!-- <v-img
                                            v-if="
                                              mission.image && !imagePreview
                                            "
                                            :src="baseURL + mission.image"
                                            width="400px"
                                            height="200px"
                                            class="align-center"
                                          /><br /> -->
                                          <v-img
                                            v-if="imagePreview"
                                            :src="imagePreview"
                                            width="400px"
                                            height="200px"
                                            class="align-center"
                                            contain
                                          /><br />
                                          <v-btn
                                            outlined
                                            @click="$refs.showImage.click()"
                                            >Upload Image
                                            <v-item-group>
                                              <input
                                                v-show="false"
                                                label="Upload Image"
                                                ref="showImage"
                                                id="file"
                                                type="file"
                                                style="display: none"
                                                @change="showImage"
                                              />
                                              <!-- </v-file-input> -->
                                            </v-item-group>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="editdialog2 = false"
                                      >
                                        Close
                                      </v-btn>
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        :disabled="!addslider"
                                        @click="addMission()"
                                      >
                                        Save
                                      </v-btn>
                                    </v-card-actions>
                                  </v-form>
                                </v-card>
                              </v-dialog>
                            </v-flex>
                            <br />
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-tab-item>
              <v-tab-item>
                <div v-if="!storage.values">
                  <v-dialog
                    :retain-focus="false"
                    v-model="dialog"
                    persistent
                    max-width="600px"
                    :key="dialog"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn outlined color="red" v-bind="attrs" v-on="on">
                        Add
                      </v-btn>
                    </template>
                    <v-card>
                      <v-form v-model="addslider">
                        <v-card-title>
                          <span class="headline">Add Values</span>
                        </v-card-title>
                        <v-card-text>
                          <v-layout>
                            <v-flex xs12 md12 lg12>
                              <v-text-field
                                row="4"
                                outlined
                                v-model="vsheading"
                                label="Heading"
                                :rules="[rules.required]"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs12 md12 lg12>
                              <v-textarea
                                row="4"
                                outlined
                                v-model="vstext"
                                label="Text"
                                :rules="[rules.required]"
                                required
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs12 md12 lg12>
                              <v-img
                                v-if="imagePreview"
                                :src="imagePreview"
                                width="400px"
                                height="200px"
                                class="align-center"
                                contain
                              /><br />
                              <v-btn outlined @click="$refs.showImage.click()"
                                >Upload Image
                                <v-item-group>
                                  <input
                                    v-show="false"
                                    label="Upload Image"
                                    ref="showImage"
                                    id="file"
                                    type="file"
                                    style="display: none"
                                    @change="showImage"
                                  />
                                  <!-- </v-file-input> -->
                                </v-item-group>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="dialogclose()"
                          >
                            Close
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            :disabled="!addslider"
                            @click="addValues()"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </div>
                <div v-else>
                  <v-container grid-list-md>
                    <v-layout wrap pt-10 pb-10>
                      <v-flex md3 pa-4>
                        <v-card
                          style="line-height: 16px; cursor: pointer"
                          v-if="storage.values.image"
                          tile
                          flat
                        >
                          <v-img
                            contain
                            :src="baseURL + storage.values.image"
                            height="300px"
                            cover
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#FF2323"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <v-layout wrap justify-center px-2>
                            <br />
                            <v-flex px-4 xl2 justify-center>
                              <span
                                style="
                                  font-size: 16px;
                                  color: #000000;
                                  font-weight: bold;
                                "
                              >
                                {{ storage.values.heading }}
                              </span>
                            </v-flex>
                            <v-flex px-4 xl2 justify-center>
                              <span style="font-size: 16px; color: #000000">
                                {{ storage.values.text }}
                              </span>
                            </v-flex>
                            <v-flex pt-5 px-4 xl2 justify-center>
                              <v-dialog v-model="editdialog3" max-width="600px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    small
                                    class="mr-2"
                                    outlined
                                    v-on="on"
                                    v-bind="attrs"
                                    color="red"
                                  >
                                    Edit
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-form v-model="addslider">
                                    <v-card-title>
                                      <span class="headline">Edit Values</span>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-layout>
                                        <v-flex xs12 md12 lg12>
                                          <v-text-field
                                            row="4"
                                            outlined
                                            v-model="vsheading"
                                            label="Heading"
                                            :rules="[rules.required]"
                                            required
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout>
                                        <v-flex xs12 md12 lg12>
                                          <v-textarea
                                            outlined
                                            row="4"
                                            v-model="vstext"
                                            label="Text"
                                            :rules="[rules.required]"
                                            required
                                          ></v-textarea>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout wrap>
                                        <v-flex xs12 md12 lg12>
                                          <!-- <v-img
                                            v-if="values.image && !imagePreview"
                                            :src="baseURL + values.image"
                                            width="400px"
                                            height="200px"
                                            class="align-center"
                                          /><br /> -->
                                          <v-img
                                            v-if="imagePreview"
                                            :src="imagePreview"
                                            width="400px"
                                            height="200px"
                                            class="align-center"
                                            contain
                                          /><br />
                                          <v-btn
                                            outlined
                                            @click="$refs.showImage.click()"
                                            >Upload Image
                                            <v-item-group>
                                              <input
                                                v-show="false"
                                                label="Upload Image"
                                                ref="showImage"
                                                id="file"
                                                type="file"
                                                style="display: none"
                                                @change="showImage"
                                              />
                                              <!-- </v-file-input> -->
                                            </v-item-group>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="editdialog3 = false"
                                      >
                                        Close
                                      </v-btn>
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        :disabled="!addslider"
                                        @click="addValues()"
                                      >
                                        Save
                                      </v-btn>
                                    </v-card-actions>
                                  </v-form>
                                </v-card>
                              </v-dialog>
                            </v-flex>
                            <br />
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
          <!-- <div v-else>
            <v-layout justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span
                  style="
                    font-size: 22px;
                    font-family: poppinssemibold;
                    letter-spacing: 1px;
                  "
                >
                  No slider Found...
                  <br />
                  Try adding Data.
                </span>
              </v-flex>
            </v-layout>
          </div> -->
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      file: null,
      showPreview: false,
      imagePreview: null,
      image: null,

      msg: null,
      showSnackBar: false,
      timeout: 5000,
      appLoading: false,

      pages: 0,
      widthOfCard: "250px",
      vtext: null,
      vheading: null,
      mtext: null,
      mheading: null,
      vstext: null,
      vsheading: null,

      dialogDelete: false,
      search: "",
      ratings: [],
      dialog: false,
      editdialog1: false,
      editdialog2: false,
      editdialog3: false,

      ServerError: false,
      vision: [],
      storage: [],
      mission: [],
      values: [],
      addslider: false,
      imgId: "",
      tab: null,
      items: ["Vision", "Mission", "Values"],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/aboutus/view",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.storage = response.data.data;
            this.vision = response.data.data.vision;
            this.vtext = this.vision.text;
            this.vheading = this.vision.heading;
            this.mission = response.data.data.mission;
            this.mtext = this.mission.text;
            this.mheading = this.mission.heading;
            this.values = response.data.data.values;
            this.vsheading = this.values.heading;
            this.vstext = this.values.text;
          } else {
            this.appLoading = false;
            this.storage = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    dialogclose() {
      this.text = null;
      this.dialog = false;
    },

    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      this.showPreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    addVision() {
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("text", this.vtext);
      formData.append("heading", this.vheading);

      axios({
        method: "POST",
        url: "/aboutus/vision/add/update",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.vtext = null;
            this.vheading = null;
            this.file = null;
            this.imagePreview = null;
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
            this.editdialog1 = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addMission() {
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("text", this.mtext);
      formData.append("heading", this.mheading);

      axios({
        method: "POST",
        url: "/aboutus/mission/add/update",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.mtext = null;
            this.mheading = null;
            this.file = null;
            this.imagePreview = null;
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
            this.editdialog2 = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addValues() {
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("text", this.vstext);
      formData.append("heading", this.vsheading);

      axios({
        method: "POST",
        url: "/aboutus/values/add/update",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.vstext = null;
            this.vsheading = null;
            this.file = null;
            this.imagePreview = null;
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
            this.editdialog3 = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false; 
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>